import { useState, ReactElement } from "react"
import { gql } from "shared/lib/graphql"
import { graphQueryBang } from "shared/lib/graphql"
import parse from "html-react-parser"
import styles from "./index.module.scss"
import classnames from "classnames"

import checkmark from "images/components/checkmark.svg?raw"

interface Props {
  link: string
  description: string
  skippable: boolean | null
  itemKey: string
  channel_module_name: string
  step_module_name: string
  step_type: string
  satisfied: boolean
}

const SkipChecklistItemMutation = gql`
  mutation SkipChecklistItemMutation(
    $key: String!
    $channel_module_name: String!
    $step_module_name: String
    $step_type: String
  ) {
    skipChecklistItem(
      input: {
        key: $key
        channel_module_name: $channel_module_name
        step_module_name: $step_module_name
        step_type: $step_type
        enabled: true
      }
    ) {
      errors {
        attribute
        message
      }
    }
  }
`

const DeveloperChecklistItem = ({
  description,
  link,
  skippable = null,
  itemKey,
  channel_module_name,
  step_module_name,
  step_type,
  satisfied: satisfiedInitial,
}: Props): ReactElement | null => {
  const [loading, setLoading] = useState(false)
  const [satisfied, setSatisfied] = useState(satisfiedInitial)

  const onClick = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    await graphQueryBang(SkipChecklistItemMutation, {
      key: itemKey,
      channel_module_name,
      step_module_name,
      step_type,
    })
    setLoading(false)
    setSatisfied(true)
  }

  return satisfied ? (
    <li className={classnames(styles["progress-item"], styles["passing"])}>
      <div>{description}</div>
      <div>{parse(checkmark)}</div>
    </li>
  ) : (
    <a href={link}>
      <li className={classnames(styles["progress-item"], styles["failing"], { [styles["skippable"]]: skippable })}>
        <div>{description}</div>
        {skippable && (
          <button disabled={loading} onClick={onClick}>
            Skip
          </button>
        )}
      </li>
    </a>
  )
}

export default DeveloperChecklistItem
